import { IconChevronDown } from '@tabler/icons-react'
import { ReactNode } from 'react'
import { components as RSComponents, DropdownIndicatorProps, GroupBase } from 'react-select'

import { SizeOptions } from '../../../../types/types'
import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { AstraButton } from '../../AstraButton/AstraButton'
import { SelectOption } from '../../AstraSelect'

export type AstraMultiSelectDropdownIndicatorProps<T> = DropdownIndicatorProps<SelectOption<T>, true, GroupBase<SelectOption<T>>> & {
    icon: ReactNode
    size?: SizeOptions
}

export const AstraMultiSelectDropdownIndicator = <T,>({ icon, isDisabled, size = 'small', ...props }: AstraMultiSelectDropdownIndicatorProps<T>) => (
    <RSComponents.DropdownIndicator isDisabled={isDisabled} {...props}>
        {<AstraButton variant="ghost" size={size} icon={icon ? icon : <AstraIcon icon={IconChevronDown} />} disabled={isDisabled} />}
    </RSComponents.DropdownIndicator>
)
